/**
 * Limited-time offers: copy a promo code, and reveal the offers held back.
 *
 * Delegated from the document for the same reason pdp-share is: the product
 * section re-renders through the Section Rendering API on every variant
 * change, so any listener bound to these buttons would be pointing at nodes
 * that have since been replaced.
 *
 * Loaded as a module -- fetched and run once however many blocks reference it.
 */
(function () {
  'use strict';

  var RESET_AFTER = 1800;

  function confirmCopy(button) {
    button.classList.add('pdp-offers__code--done');
    window.setTimeout(function () {
      button.classList.remove('pdp-offers__code--done');
    }, RESET_AFTER);
  }

  function legacyCopy(text, button) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;inset-block-start:-9999px;opacity:0;';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
      confirmCopy(button);
    } catch (e) {
      /* Left silent on purpose: a confirmation for a copy that did not happen
         is worse than no confirmation, because the shopper pastes nothing into
         the checkout and blames the code. */
    }
    document.body.removeChild(field);
  }

  function copy(text, button) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(
        function () {
          confirmCopy(button);
        },
        function () {
          legacyCopy(text, button);
        }
      );
      return;
    }
    legacyCopy(text, button);
  }

  document.addEventListener('click', function (event) {
    var codeButton = event.target.closest('[data-pdp-offer-code]');
    if (codeButton) {
      event.preventDefault();
      var code = codeButton.getAttribute('data-pdp-offer-code');
      if (code) copy(code, codeButton);
      return;
    }

    /* "View all coupons", in the price box or the cart. The dialog is looked
       up inside the same [data-coupons-scope] as the link, because a product
       page can carry both -- its own and the cart drawer's. */
    var openCoupons = event.target.closest('[data-pdp-coupons-open]');
    if (openCoupons) {
      event.preventDefault();
      var scope = openCoupons.closest('[data-coupons-scope]') || document;
      var dialog = scope.querySelector('[data-pdp-coupons]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    var closeCoupons = event.target.closest('[data-pdp-coupons-close]');
    if (closeCoupons) {
      var owner = closeCoupons.closest('dialog');
      if (owner) owner.close();
      return;
    }

    /* A click that lands on the <dialog> element itself, rather than anything
       inside it, is a click on the backdrop -- the panel's own padding is
       covered by its children. */
    if (event.target.matches && event.target.matches('[data-pdp-coupons]')) {
      event.target.close();
      return;
    }

    var more = event.target.closest('[data-pdp-offers-more]');
    if (!more) return;

    event.preventDefault();

    /* Scoped to this block's own list. Two offer blocks on one page is not a
       layout anyone has built, but querySelector on the document would make
       the first one's button expand the second one's list if it ever were. */
    var wrapper = more.closest('.pdp-offers');
    var list = wrapper && wrapper.querySelector('[data-pdp-offers]');
    if (!list) return;

    list.classList.add('pdp-offers__list--expanded');

    /* The control is spent once used -- it only ever reveals. Removed rather
       than toggled back to "Show all offers", which would read as a second
       action that does something new. */
    more.remove();
  });
})();
